var dotaSeason = {
  0: function(score) {
    var obj = { score: score };
    if (score < 200) {
      obj.level = 1;
      obj.star = score % 100;
      obj.empty = 4 - obj.star;
      obj.half = false;
      obj.name = "门徒";
    } else if (score < 300) {
      obj.level = 2;
      obj.star = score % 100;
      obj.empty = 4 - obj.star;
      obj.half = false;
      obj.name = "勇士";
    } else if (score < 400) {
      obj.level = 3;
      obj.star = score % 100;
      obj.empty = 4 - obj.star;
      obj.half = false;
      obj.name = "精英";
    } else if (score < 500) {
      obj.level = 4;
      obj.star = score % 100;
      obj.empty = 4 - obj.star;
      obj.half = false;
      obj.name = "大师";
    } else if (score < 600) {
      obj.level = 5;
      obj.star = score % 100;
      obj.empty = 4 - obj.star;
      obj.half = false;
      obj.name = "战神";
    } else if (score < 700) {
      obj.level = 6;
      obj.star = score % 100;
      obj.empty = 4 - obj.star;
      obj.half = false;
      obj.name = "传奇";
    } else if (score < 800) {
      obj.level = 7;
      obj.star = Math.floor((score % 100) / 2);
      obj.half = score % 100 & 1 ? true : false;
      obj.empty = obj.half ? 3 - obj.star : 4 - obj.star;
      obj.name = "超凡至尊Ⅰ";
    } else if (score < 900) {
      obj.level = 8;
      obj.star = Math.floor((score % 100) / 2);
      obj.half = score % 100 & 1 ? true : false;
      obj.empty = obj.half ? 3 - obj.star : 4 - obj.star;
      obj.name = "超凡至尊Ⅱ";
    } else if (score < 1000) {
      obj.level = 9;
      obj.star = Math.floor((score % 100) / 2);
      obj.half = score % 100 & 1 ? true : false;
      obj.empty = obj.half ? 3 - obj.star : 4 - obj.star;
      obj.name = "超凡至尊Ⅲ";
    } else if (score < 1100) {
      obj.level = 10;
      obj.star = Math.floor((score % 100) / 2);
      obj.half = score % 100 & 1 ? true : false;
      obj.empty = obj.half ? 3 - obj.star : 4 - obj.star;
      obj.name = "超凡至尊Ⅳ";
    } else if (score < 1200) {
      obj.level = 11;
      obj.star = Math.floor((score % 100) / 2);
      obj.half = score % 100 & 1 ? true : false;
      obj.empty = obj.half ? 3 - obj.star : 4 - obj.star;
      obj.name = "超凡至尊Ⅴ";
    } else if (score < 1300) {
      obj.level = 12;
      obj.star = Math.floor((score % 100) / 2);
      obj.half = score % 100 & 1 ? true : false;
      obj.empty = obj.half ? 3 - obj.star : 4 - obj.star;
      obj.name = "超凡至尊Ⅵ";
    } else if (score < 1400) {
      obj.level = 13;
      obj.star = Math.floor((score % 100) / 2);
      obj.half = score % 100 & 1 ? true : false;
      obj.empty = obj.half ? 3 - obj.star : 4 - obj.star;
      obj.name = "超凡至尊Ⅶ";
    } else if (score < 1500) {
      obj.level = 14;
      obj.star = Math.floor((score % 100) / 2);
      obj.half = score % 100 & 1 ? true : false;
      obj.empty = obj.half ? 3 - obj.star : 4 - obj.star;
      obj.name = "超凡至尊Ⅷ";
    } else if (score < 1600) {
      obj.level = 15;
      obj.star = Math.floor((score % 100) / 2);
      obj.half = score % 100 & 1 ? true : false;
      obj.empty = obj.half ? 3 - obj.star : 4 - obj.star;
      obj.name = "超凡至尊Ⅸ";
    } else if (score == 1600) {
      obj.level = 16;
      obj.star = Math.floor((score % 100) / 2);
      obj.half = score % 100 & 1 ? true : false;
      obj.empty = obj.half ? 3 - obj.star : 4 - obj.star;
      obj.name = "超凡至尊Ⅹ";
    } else {
      obj.level = 17;
      obj.star = Math.floor((score % 100) / 2);
      obj.half = score % 100 & 1 ? true : false;
      obj.empty = obj.half ? 3 - obj.star : 4 - obj.star;
      obj.name = "天榜至尊";
    }
    return obj;
  },
  //s36及之后的段位计算（dota\im\omg\ds\）
  1: function(score) {
    var obj = { score: score };
    if (score < 200) {
      obj.level = 3;
      obj.star = score % 100;
      obj.empty = 4 - obj.star;
      obj.half = false;
      obj.name = "精英";
    } else if (score < 300) {
      obj.level = 3;
      obj.star = score % 100;
      obj.empty = 4 - obj.star;
      obj.half = false;
      obj.name = "精英";
    } else if (score < 400) {
      obj.level = 3;
      obj.star = score % 100;
      obj.empty = 4 - obj.star;
      obj.half = false;
      obj.name = "精英";
    } else if (score < 500) {
      obj.level = 4;
      obj.star = score % 100;
      obj.empty = 4 - obj.star;
      obj.half = false;
      obj.name = "大师";
    } else if (score < 600) {
      obj.level = 5;
      obj.star = score % 100;
      obj.empty = 4 - obj.star;
      obj.half = false;
      obj.name = "战神";
    } else if (score < 700) {
      obj.level = 6;
      obj.star = score % 100;
      obj.empty = 4 - obj.star;
      obj.half = false;
      obj.name = "传奇";
    } else if (score < 800) {
      obj.level = 7;
      obj.star = score % 100;
      obj.empty = 4 - obj.star;
      obj.half = false;
      obj.name = "超凡至尊Ⅰ";
    } else if (score < 900) {
      obj.level = 8;
      obj.star = score % 100;
      obj.empty = 4 - obj.star;
      obj.half = false;
      obj.name = "超凡至尊Ⅱ";
    } else if (score < 1000) {
      obj.level = 9;
      obj.star = score % 100;
      obj.empty = 4 - obj.star;
      obj.half = false;
      obj.name = "超凡至尊Ⅲ";
    } else if (score < 1100) {
      obj.level = 10;
      obj.star = score % 100;
      obj.empty = 4 - obj.star;
      obj.half = false;
      obj.name = "超凡至尊Ⅳ";
    } else if (score < 1200) {
      obj.level = 11;
      obj.star = score % 100;
      obj.empty = 4 - obj.star;
      obj.half = false;
      obj.name = "超凡至尊Ⅴ";
    } else if (score < 1300) {
      obj.level = 12;
      obj.star = Math.floor((score % 100) / 2);
      obj.half = score % 100 & 1 ? true : false;
      obj.empty = obj.half ? 3 - obj.star : 4 - obj.star;
      obj.name = "王者至尊Ⅰ";
    } else if (score < 1400) {
      obj.level = 13;
      obj.star = Math.floor((score % 100) / 2);
      obj.half = score % 100 & 1 ? true : false;
      obj.empty = obj.half ? 3 - obj.star : 4 - obj.star;
      obj.name = "王者至尊Ⅱ";
    } else if (score < 1500) {
      obj.level = 14;
      obj.star = Math.floor((score % 100) / 2);
      obj.half = score % 100 & 1 ? true : false;
      obj.empty = obj.half ? 3 - obj.star : 4 - obj.star;
      obj.name = "王者至尊Ⅲ";
    } else if (score < 1600) {
      obj.level = 15;
      obj.star = Math.floor((score % 100) / 2);
      obj.half = score % 100 & 1 ? true : false;
      obj.empty = obj.half ? 3 - obj.star : 4 - obj.star;
      obj.name = "王者至尊Ⅳ";
    } else if (score < 1700) {
      obj.level = 16;
      obj.star = Math.floor((score % 100) / 2);
      obj.half = score % 100 & 1 ? true : false;
      obj.empty = obj.half ? 3 - obj.star : 4 - obj.star;
      obj.name = "王者至尊Ⅴ";
    } else {
      obj.level = 17;
      obj.star = Math.floor((score % 100) / 2);
      obj.half = score % 100 & 1 ? true : false;
      obj.empty = obj.half ? 3 - obj.star : 4 - obj.star;
      obj.name = "天榜至尊";
    }
    return obj;
  },
  5: function(score) {
    var obj = { score: score };
    if (score < 200) {
      obj.name = "门徒";
      obj.level = 1;
      obj.star = score % 100;
    } else if (score < 300) {
      obj.name = "勇士";
      obj.level = 2;
      obj.star = score % 100;
    } else if (score < 400) {
      obj.name = "精英";
      obj.level = 3;
      obj.star = score % 100;
    } else if (score < 500) {
      obj.star = score % 100;
      obj.level = 4;
      obj.name = "大师";
    } else if (score < 600) {
      obj.star = score % 100;
      obj.level = 5;
      obj.name = "战神";
    } else if (score < 700) {
      obj.star = score % 100;
      obj.level = 6;
      obj.name = "传奇";
    } else {
      obj.level = 7;
      obj.name = "超凡至尊";
      obj.star = 0;
    }
    obj.empty = 4 - obj.star;
    return obj;
  },
  4: function(score) {
    var obj = { score: score };
    if (score < 200) {
      obj.name = "门徒";
      obj.level = 1;
      obj.star = score % 100;
    } else if (score < 300) {
      obj.name = "勇士";
      obj.level = 2;
      obj.star = score % 100;
    } else if (score < 400) {
      obj.name = "精英";
      obj.level = 3;
      obj.star = score % 100;
    } else if (score < 500) {
      obj.star = score % 100;
      obj.level = 4;
      obj.name = "大师";
    } else if (score < 600) {
      obj.star = score % 100;
      obj.level = 5;
      obj.name = "战神";
    } else {
      obj.level = 6;
      obj.name = "不朽传奇";
      obj.star = 0;
    }
    obj.empty = 4 - obj.star;
    return obj;
  },
  3: function(score) {
    var obj = { score: score };
    if (score <= 0) {
      obj.name = "待定";
      obj.level = 0;
      obj.star = 0;
    } else if (score >= 0 && score <= 299) {
      obj.name = "门徒";
      obj.level = 1;
      if (score <= 149) {
        obj.star = "3";
      } else if (score <= 199) {
        obj.star = "2";
      } else {
        obj.star = "1";
      }
    } else if (score > 299 && score <= 449) {
      obj.name = "勇士";
      obj.level = 2;
      if (score <= 349) {
        obj.star = "3";
      } else if (score <= 399) {
        obj.star = "2";
      } else {
        obj.star = "1";
      }
    } else if (score > 449 && score <= 599) {
      obj.name = "精英";
      obj.level = 3;
      if (score <= 499) {
        obj.star = "3";
      } else if (score <= 549) {
        obj.star = "2";
      } else {
        obj.star = "1";
      }
    } else if (score > 599 && score <= 899) {
      obj.name = "大师";
      obj.level = 4;
      if (score <= 699) {
        obj.star = "3";
      } else if (score <= 799) {
        obj.star = "2";
      } else {
        obj.star = "1";
      }
    } else if (score > 899 && score <= 3999) {
      obj.name = "战神";
      obj.level = 5;
      if (score <= 1099) {
        obj.star = "3";
      } else if (score <= 1399) {
        obj.star = "2";
      } else {
        obj.star = "1";
      }
    } else {
      obj.name = "不朽传奇";
      obj.level = 6;
      obj.star = "1";
    }
    return obj;
  },
  2: function(score) {
    var obj = { score: score };
    if (score <= 0) {
      obj.name = "待定";
      obj.level = 0;
      obj.star = 0;
    } else if (score >= 0 && score < 600) {
      obj.name = "门徒";
      obj.level = 1;
      if (score <= 399) {
        obj.star = "3";
      } else if (score <= 499) {
        obj.star = "2";
      } else {
        obj.star = "1";
      }
    } else if (score >= 600 && score <= 899) {
      obj.name = "勇士";
      obj.level = 2;
      if (score <= 699) {
        obj.star = "3";
      } else if (score <= 799) {
        obj.star = "2";
      } else {
        obj.star = "1";
      }
    } else if (score >= 900 && score <= 1499) {
      obj.name = "精英";
      obj.level = 3;
      if (score <= 1099) {
        obj.star = "3";
      } else if (score <= 1199) {
        obj.star = "2";
      } else {
        obj.star = "1";
      }
    } else if (score >= 1500 && score <= 2999) {
      obj.name = "大师";
      obj.level = 4;
      if (score <= 1999) {
        obj.star = "3";
      } else if (score <= 2499) {
        obj.star = "2";
      } else {
        obj.star = "1";
      }
    } else if (score >= 3000 && score <= 4999) {
      obj.name = "战神";
      obj.level = 5;
      if (score <= 3499) {
        obj.star = "3";
      } else if (score <= 3999) {
        obj.star = "2";
      } else {
        obj.star = "1";
      }
    } else {
      obj.name = "不朽传奇";
      obj.level = 6;
      obj.star = "1";
    }
    return obj;
  },
  139: function(score) {
    let level = "";
    if (score >= 100 && score < 350) {
      if (score >= 100 && score < 150) {
        level = "青铜Ⅰ";
      } else if (score >= 150 && score < 200) {
        level = "青铜Ⅱ";
      } else if (score >= 200 && score < 250) {
        level = "青铜Ⅲ";
      } else if (score >= 250 && score < 300) {
        level = "青铜Ⅳ";
      } else if (score >= 300 && score < 350) {
        level = "青铜Ⅴ";
      }
    } else if (score >= 350 && score < 600) {
      if (score >= 350 && score < 400) {
        level = "白银Ⅰ";
      } else if (score >= 400 && score < 450) {
        level = "白银Ⅱ";
      } else if (score >= 450 && score < 500) {
        level = "白银Ⅲ";
      } else if (score >= 500 && score < 550) {
        level = "白银Ⅳ";
      } else if (score >= 550 && score < 600) {
        level = "白银Ⅴ";
      }
    } else if (score >= 600 && score < 900) {
      if (score >= 600 && score < 660) {
        level = "黄金Ⅰ";
      } else if (score >= 660 && score < 720) {
        level = "黄金Ⅱ";
      } else if (score >= 720 && score < 780) {
        level = "黄金Ⅲ";
      } else if (score >= 780 && score < 840) {
        level = "黄金Ⅳ";
      } else if (score >= 840 && score < 900) {
        level = "黄金Ⅴ";
      }
    } else if (score >= 900 && score < 1250) {
      if (score >= 900 && score < 970) {
        level = "铂金Ⅰ";
      } else if (score >= 970 && score < 1040) {
        level = "铂金Ⅱ";
      } else if (score >= 1040 && score < 1110) {
        level = "铂金Ⅲ";
      } else if (score >= 1110 && score < 1180) {
        level = "铂金Ⅳ";
      } else if (score >= 1180 && score < 1250) {
        level = "铂金Ⅴ";
      }
    } else if (score >= 1250 && score < 1750) {
      if (score >= 1250 && score < 1350) {
        level = "超凡Ⅰ";
      } else if (score >= 1350 && score < 1450) {
        level = "超凡Ⅱ";
      } else if (score >= 1450 && score < 1550) {
        level = "超凡Ⅲ";
      } else if (score >= 1550 && score < 1650) {
        level = "超凡Ⅳ";
      } else if (score >= 1650 && score < 1750) {
        level = "超凡Ⅴ";
      }
    } else if (score >= 1750) {
      if (score >= 1750 && score < 1900) {
        level = "至尊Ⅰ";
      } else if (score >= 1900 && score < 2050) {
        level = "至尊Ⅱ";
      } else if (score >= 2050 && score < 2200) {
        level = "至尊Ⅲ";
      } else if (score >= 2200 && score < 2350) {
        level = "至尊Ⅳ";
      } else if (score >= 2350) {
        level = "至尊Ⅴ";
      }
    }
    return level;
  }
};

export default dotaSeason;



// WEBPACK FOOTER //
// ./src/assets/js/s27/seasondan.js